exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1_bDZhgYjxNfA0Boy_cXeh{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._1_bDZhgYjxNfA0Boy_cXeh{padding:0 8px}", ""]);
// Exports
exports.locals = {
	"container": "_1_bDZhgYjxNfA0Boy_cXeh"
};